import React from "react";

// The one "there is nothing here" block.
//
// Every screen used to write its own — "No banks found." in a <p>, a centred
// <div className="py-8 text-gray-500">, a table cell with different padding —
// so an empty list looked different on every screen. This is the markup the
// shared DataTable already drew inline, lifted out so non-table screens
// (card grids, panels, tabs) can use exactly the same thing.
//
//   <EmptyState message="No banks found" hint="Click 'Add Bank' above." />
//   <EmptyState icon={<HiOutlineBell className="h-10 w-10" />} message="No alerts" />
const DefaultIcon = (
  <svg
    className="h-10 w-10 text-gray-300"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-4l-2 3h-4l-2-3H4"
    />
  </svg>
);

const EmptyState = ({
  icon,
  message = "No records found",
  hint,
  action,
  className = "",
}) => (
  <div className={`flex flex-col items-center gap-2 ${className}`.trim()}>
    {icon === null ? null : (
      <span className="text-gray-300">{icon || DefaultIcon}</span>
    )}
    <div className="text-sm font-medium text-gray-700">{message}</div>
    {hint && <div className="text-xs text-gray-400">{hint}</div>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export default EmptyState;
